var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMedi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 5C21.5523 5 22 5.44772 22 6V12.5H28.5C29.0523 12.5 29.5 12.9477 29.5 13.5V21.5C29.5 22.0523 29.0523 22.5 28.5 22.5H22V29C22 29.5523 21.5523 30 21 30H13C12.4477 30 12 29.5523 12 29V22.5H5.5C4.94772 22.5 4.5 22.0523 4.5 21.5V13.5C4.5 12.9477 4.94772 12.5 5.5 12.5H12V6C12 5.44772 12.4477 5 13 5H21Z",
    fill: "#FF5454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedi);
export default __webpack_public_path__ + "static/media/icon_medi.6c12e4b25b22f783aca5ee874be02624.svg";
export { ForwardRef as ReactComponent };